import React, { useEffect } from 'react'
import { Box, Divider, Grid, styled, Typography, useMediaQuery, useTheme } from '@mui/material'
import LogoName from '../../../assets/images/logo/LogoName-2.svg';
import SocialMediaLink from './top/socialMediaLinks/SocialMediaLink';
import Address_Email from './firstColumn/Address_Email';
import Resources from './thirdColumn/Resources';
import Support from './secondColumn/Support';
import LegalLinks from './fourthColumn/LegalLinks';
import NewsLetter from './bottom/newsLetter/NewsLetter';
import { Link, useNavigate } from 'react-router-dom';
import img from '../../../assets/images/logo/finalLogo.svg';

const MainBox = styled(Box)(({ theme }) => ({
  width: '100%',
  background: "#242424",
  display: "flex",
  flexDirection: 'column',
  alignItems: "center",
  userSelect: "none",
  color: 'white',
  paddingBottom: theme.spacing(3),
}));

const LogoBox = styled(Box)(({ theme }) => ({
  width: '7.3rem',
  height: '3rem',
  marginLeft: '4rem',
  marginTop: '0.5rem',
  [theme.breakpoints.down('sm')]: {
    width: '5.9rem',
    height: '2.4rem',
    marginLeft: '2rem',
    
  }
}));

const LogoIcon = styled(Box)(({ theme }) => ({
  width: '13rem',
  height: '13rem',
  marginLeft: '1.5rem',
  [theme.breakpoints.down('sm')]: {
    width: '9rem',
    height: '9rem',
    marginLeft: '1rem',
    
  }
}));

function Footer() {

  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to top whenever pathname changes
  }, []);

  const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // Mobile screen check

  return (
    <>
      <MainBox>
        <Box sx={{  width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} >
          <Link to="/" ><LogoBox component="img" src={LogoName} /></Link>
          <SocialMediaLink/>
        </Box>

        <Divider sx={{ width: '100%', borderBottom: '1px solid white', mb: 2 }} />
        
        <Box sx={{  width: '100%', display: 'flex', flexDirection: { xs: 'column', md: 'row' }, justifyContent: 'space-evenly', alignItems: 'start' }} >
            {/* { !isMobile && */}
          <Box sx={{ width: { xs: '100%', md: '20%' }, py: 2.4, display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
            <LogoIcon component="img" src={img} />
          </Box>
            {/* } */}

          <Box sx={{ width: { xs: '100%', md: '80%' }, display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center' }} >
            <Box sx={{ width: '100%', display: 'flex', gap: { xs: 2, md: 0 }, flexDirection: { xs: 'column', md: 'row' }, justifyContent: 'space-evenly', alignItems: { xs: 'center', md: 'start' } }} >
              <Address_Email/>
              <Box sx={{ width: '100%', display: { xs: 'grid', md: 'flex' }, gridTemplateColumns: 'auto auto', justifyContent: 'space-evenly', alignItems: 'start' }}>
                <Support/>
                <Resources/>
                <LegalLinks/>
              </Box>
            </Box>
          </Box>

        </Box>

      </MainBox>
    </>
  )
}

export default Footer
